<template>
  <div v-if="checkable" class="list__column list__checkable">
    <div class="checkbox-primary custom-control custom-checkbox">
      <input
        :id="'item-' + idKey ? row[idKey] : row.id ? row.id : id"
        v-model="listCheck"
        :checked="checkAllRows"
        :value="idKey ? row[idKey] : row.id ? row.id : id"
        class="custom-control-input"
        name="listCheck"
        type="checkbox"
        @change="changeListCheck"
      />
      <label :for="'item-' + idKey ? row[idKey] : row.id ? row.id : id" class="custom-control-label"></label>
    </div>
  </div>
  <FontAwesomeIcon
    v-if="row[4] === 'Non'"
    class="me-1"
    icon="fa-light fa-triangle-exclamation"
    style="color: orange; margin-top: 10px"
  />
  <FontAwesomeIcon
    v-if="row[4] === 'Oui'"
    class="me-1 text-success"
    icon="fa-light fa-check"
    style="margin-top: 10px"
  />
  <div
    v-for="(column, index) in columnsItem"
    :key="column.name"
    :class="
      (column.textOverflowHidden ? 'text-overflow-hidden ' : '') +
      'list__column width w ' +
      (type === 'template' && index === 0 ? ' template-col' : '') +
      (type === 'template' && index === 1 ? ' template-col-1' : '') +
      (type === 'training' && index === 1 ? ' training-col' : '') +
      (type === 'ypareo_reporting' && (index === 1 || index === 2) ? ' ypareo-col' : '') +
      (type === 'ypareo_reporting_view' && index === 2 ? ' ypareo-view-col' : '') +
      (shouldReduceWidth(index) ? ' -small' : '') +
      (shouldExpandWidth(index) ? ' -big' : '')
    "
    :style="'--maxColumn:' + nbColumns"
  >
    <div v-if="linkKey === column.index && linkRouteName">
      <SortTableRouterTypeComponent
        :linkRouteName="linkRouteName"
        :row="row"
        :column="column"
        :nbColumns="nbColumns"
        :idKey="idKey"
        :queryName="queryName"
        :linkInactiveCondition="linkInactiveCondition"
      />
    </div>
    <div
      v-else-if="
        typeof (row.keyName ? row[keyName][column.name] : row[column.index ? column.index : column.name]) ===
          'boolean' &&
        (!type || (type && type !== 'absence' && type !== 'planning'))
      "
      class="d-flex align-items-center"
    >
      <div class="d-lg-none col-5">
        <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
      </div>
      <span
        :class="
          'col-lg-12 col-8 font-size list__dot bg-' +
          ((row.keyName ? row[keyName][column.name] : row[column.index ? column.index : column.name])
            ? 'success'
            : 'danger')
        "
      >
      </span>
    </div>
    <SortTableAbsenceStatusComponent
      v-else-if="
        typeof (row.keyName ? row[keyName][column.name] : row[column.index ? column.index : column.name]) ===
          'boolean' &&
        type &&
        (type === 'absence' || 'planning')
      "
      :columns="columns"
      :column="column"
      :row="row"
      :type="type"
      :nbColumns="nbColumns"
      :idKey="idKey"
      @justifyAbsence="justifyAbsence"
      @verifyAbsence="verifyAbsence"
      @downloadJustificativeFile="downloadJustificativeFile"
    />
    <SortTableAbsenceTypeComponent
      v-else-if="
        type === 'absence' &&
        (row[column.index ? column.index : column.name] === 'absence' ||
          row[column.index ? column.index : column.name] === 'presence')
      "
      :nbColumns="nbColumns"
      :row="row"
      :column="column"
    />
    <SortTableIncidentSheetComponent
      v-else-if="
        type &&
        type === 'incident_sheet' &&
        (column.name === $t('studea_manager.incident_sheet.comment') ||
          column.name === $t('studea_manager.incident_sheet.status'))
      "
      :columns="columns"
      :column="column"
      :row="row"
      :nbColumns="nbColumns"
      :idKey="idKey"
    />
    <span v-else-if="type && type === 'incident_sheet' && column.index === '0' && row && row[9] && row[10]">
      <router-link
        :to="{
          name: 'questionnaire',
          params: {
            questionnaireId: row[9],
            triadId: row[10],
          },
        }"
        >{{ row[column.index] }}</router-link
      >
    </span>
    <span v-else-if="type === 'mail' && column.index === '4'">
      <span
        class="list__dot"
        :class="{
          'bg-success': row[column.index] === 1,
          'bg-warning': row[column.index] === 0,
          'bg-danger': row[column.index] === 2,
        }"
      ></span>
    </span>
    <span v-else-if="typeof row[column.index ? column.index : column.name] === 'boolean'">
      <div class="d-flex align-items-center" v-if="type && type === 'absence'">
        <div class="d-lg-none col-5">
          <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
        </div>
        <div class="col-lg-12 col-8 font-size">
          {{ row[column.index ? column.index : column.name] === true ? "Oui" : "Non" }}
          <a
            :href="url"
            class="icon-link"
            v-if="row[nbColumns] && row[column.index ? column.index : column.name] === true && fileKey && row[fileKey]"
            >{{ row[column.index ? column.index : column.name][nbColumns] }}
            <FontAwesomeIcon icon="fa-light fa-download" />
          </a>
        </div>
      </div>
    </span>
    <span
      v-else-if="
        typeof row[column.index ? column.index : column.name] === 'object' &&
        row[column.index ? column.index : column.name]
      "
      class="d-flex align-items-start"
    >
      <div class="d-lg-none col-5">
        <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
      </div>
      <div class="col-7 col-lg-12">
        <div v-if="type && type === 'institution'" class="col-lg-12 col-8 font-size">
          <SortTableInstitutionCellComponent
            :institution="row[column.index ? column.index : column.name]"
            :column="column"
            :row="row"
            @initModel="initModel"
          />
        </div>
        <div
          v-else-if="type && (type === 'training' || type === 'front-training')"
          v-for="item in sortPromotionByStartDate(row[column.index ? column.index : column.name])"
          :key="item"
          class="d-flex align-items-center justify-content-lg-start justify-content-between -institution institution__actions"
        >
          <router-link
            v-if="type === 'training'"
            :to="{
              name: path,
              params: type === 'training' ? { id: item.id } : { trainingCourseId: item.id },
              query:
                type === 'training'
                  ? {
                      breadcrumbName: row[0] + '<br>' + row[1] + ' | ' + item.label,
                    }
                  : {},
            }"
            :class="'list__link ' + (item.archive ? ' -red' : ' text-info')"
            v-access:[permissions]="accessManager().EDIT"
          >
            {{ item.label }}
            <span class="nbTriad">({{ item.nbTriad }})</span>
          </router-link>
          <span
            v-else-if="type === 'front-training'"
            :class="'list__link d-flex inactive ' + (item.archive ? ' -red' : ' text-info')"
          >
            {{ item.label }} <span class="nbTriad">({{ item.nbTriad }})</span>
            <span class="ms-2 d-flex align-items-center">
              <router-link
                v-tooltip="{
                  title: this.initSettingsTooltip(),
                }"
                :to="{
                  name: 'studeaManagerHome',
                  params: { trainingCourseId: item.id },
                }"
                class="btn-icon"
              >
                <FontAwesomeIcon class="icon" icon="fa-light fa-gear" />
              </router-link>
              <button
                class="btn-icon btn-group"
                v-tooltip="{ title: $t('dashboard.training.triad_list') }"
                type="button"
                @click="showTriadList(item.id)"
              >
                <FontAwesomeIcon icon="fa-light fa-users" />
              </button> </span
          ></span>

          <div class="ms-2 d-flex align-items-center" v-if="type === 'training'">
            <router-link
              v-tooltip="{
                title: this.initSettingsTooltip(),
              }"
              :to="{
                name: 'studeaManagerHome',
                params: { trainingCourseId: item.id },
              }"
              class="btn-icon"
            >
              <FontAwesomeIcon class="icon" icon="fa-light fa-gear" />
            </router-link>
            <button
              class="btn-icon btn-group"
              v-tooltip="{
                title: $t('admin.trainingCourse.duplicate_on_next_year'),
              }"
              v-access:[permissions]="accessManager().EDIT"
              type="button"
              @click="duplicateTrainingCourseOnNextYear(item.id)"
            >
              <FontAwesomeIcon icon="fa-light fa-plus" />
            </button>
            <button
              class="btn-icon btn-group"
              v-tooltip="{
                title: $t('admin.trainingCourse.duplicate'),
              }"
              type="button"
              v-access:[permissions]="accessManager().EDIT"
              @click="duplicateTrainingCourse(item.id)"
            >
              <FontAwesomeIcon icon="fa-light fa-copy" />
            </button>
            <button
              class="btn-icon btn-group"
              v-tooltip="{
                title: $t('admin.trainingCourse.delete'),
              }"
              type="button"
              v-access:[permissions]="accessManager().DELETE"
              @click="removeTrainingCourse(item.id)"
            >
              <FontAwesomeIcon icon="fa-light fa-trash" />
            </button>
          </div>
        </div>
        <div v-if="type && type === 'template'" class="col-lg-12 col-8 font-size">
          <div v-if="Array.isArray(row[column.index ? column.index : column.name])">
            <span v-if="row[column.index ? column.index : column.name][0] === 'DEFAULT_TEMPLATE_KEY'">
              {{ $t("admin.template.default_template") }}
            </span>
            <span v-else>
              {{ row[column.index ? column.index : column.name].join(", ") }}
            </span>
          </div>
          <div v-else-if="type === 'front-training'" class="ms-2 d-flex align-items-center">
            <button
              class="btn-icon btn-group"
              v-tooltip="{ title: $t('dashboard.training.triad_list') }"
              type="button"
              @click="showTriadList(item.id)"
            >
              <FontAwesomeIcon icon="fa-light fa-users" />
            </button>
          </div>
        </div>
      </div>
    </span>
    <span
      v-else-if="
        type === 'incident_sheet' && column.index === 'questionnaireName' && row['questionnaireId'] && row['triadId']
      "
      ><router-link
        :to="{ name: 'questionnaire', params: { questionnaireId: row['questionnaireId'], triadId: row['triadId'] } }"
        v-tooltip="{ title: $t('studea_manager.incident_sheet.see_sheet'), position: 'right' }"
        >{{ row[column.index ? column.index : column.name] }}</router-link
      ></span
    >
    <div v-else-if="type === 'ypareo_reporting' && column.index === '0'" v-html="row[column.index]"></div>
    <div v-else-if="type === 'registration-alert' && column.index === 4">
      <AlertStatusComponent :status="parseInt(row[column.index])" />
    </div>
    <span v-else-if="type === 'duplication_historic' && column.index === statusKey" class="d-flex lign-items-start">
      <div class="d-lg-none col-5">
        <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
      </div>
      <div class="col-7 col-lg-12">
        <SortTableDuplicationHistoricStatusCellComponent :row="row" :column="column" />
      </div>
    </span>
    <span v-else-if="type === 'front-group' && statusKey === column.index">
      <TrainingGroupStatusComponent :status="row[column.index]" :withLabel="true" />
    </span>
    <span v-else-if="(type === 'registration' || type === 'registration-contract') && statusKey === column.index">
      <SortTableRegistrationStatusCellComponent :status="row[column.index]" :nbColumns="nbColumns" :column="column" />
    </span>

    <SortTableBasicDataCellComponent
      v-else
      :type="type"
      :nbColumns="nbColumns"
      :row="row"
      :columns="columns"
      :column="column"
      :index="index"
      :dateFormat="dateFormat"
      :idKey="idKey"
    />
  </div>
  <div v-if="Object.keys(actions).length" :class="'list__action -row ' + (actions.length <= 2 ? 'small' : '')">
    <ListActionsBlockComponent
      :id="
        idKey || (idKey !== undefined && typeof idKey === 'number' && row[idKey]) ? row[idKey] : row.id ? row.id : id
      "
      :actions="actionsItem"
      :row="row"
      @click="clickAction"
    />
  </div>
</template>

<script>
import ListActionsBlockComponent from "@/components/blocks/ListActionsBlockComponent.vue";
import SortTableInstitutionCellComponent from "@/components/table/sortTable/SortTableInstitutionCellComponent.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fileManager } from "@/services/file/file-manager";
import SortTableMobileFirstColumnComponent from "@/components/table/sortTable/SortTableMobileFirstColumnComponent.vue";
import { sortManager } from "@/services/utilities/sort-manager";
import { accessManager } from "@/services/security/access-manager";
import { mapState } from "pinia";
import { useUserStore } from "@/store/user/user";
import { usePlatformStore } from "@/store/platform/platform";
import SortTableDuplicationHistoricStatusCellComponent from "@/components/table/sortTable/SortTableDuplicationHistoricStatusCellComponent.vue";
import SortTableAbsenceStatusComponent from "@/components/table/sortTable/SortTableAbsenceStatusComponent.vue";
import TrainingGroupStatusComponent from "@/components/training/TrainingGroupStatusComponent.vue";
import SortTableIncidentSheetComponent from "@/components/table/sortTable/SortTableIncidentSheetComponent.vue";
import SortTableAbsenceTypeComponent from "@/components/table/sortTable/SortTableAbsenceTypeComponent.vue";
import AlertStatusComponent from "@/components/registration/alert/AlertStatusComponent.vue";
import SortTableRouterTypeComponent from "@/components/table/sortTable/SortTableRouterTypeComponent.vue";
import SortTableBasicDataCellComponent from "@/components/table/sortTable/SortTableBasicDataCellComponent.vue";
import SortTableRegistrationStatusCellComponent from "@/components/table/sortTable/SortTableRegistrationStatusCellComponent.vue";
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";

export default {
  name: "SortTableRowComponent",
  components: {
    SortTableRegistrationStatusCellComponent,
    SortTableBasicDataCellComponent,
    SortTableRouterTypeComponent,
    AlertStatusComponent,
    TrainingGroupStatusComponent,
    SortTableAbsenceTypeComponent,
    SortTableAbsenceStatusComponent,
    SortTableDuplicationHistoricStatusCellComponent,
    SortTableIncidentSheetComponent,
    SortTableMobileFirstColumnComponent,
    FontAwesomeIcon,
    SortTableInstitutionCellComponent,
    ListActionsBlockComponent,
  },
  props: {
    checkable: {
      default: false,
      type: Boolean,
      required: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    actions: {
      type: Array,
      required: false,
    },
    idKey: {
      default: 0,
      type: Number,
      required: false,
    },
    row: {
      type: Array,
      required: true,
    },
    nbColumns: {
      type: Number,
      required: true,
    },
    id: {
      type: [Number, String],
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    path: {
      default: "",
      type: String,
      required: false,
    },
    checkAllRows: {
      type: [Boolean, Number],
      required: false,
    },
    dateFormat: {
      default: "short",
      type: String,
      required: false,
    },
    fileKey: {
      type: Number,
      required: false,
      default: null,
    },
    statusKey: {
      type: String,
      required: false,
      default: "",
    },
    linkKey: {
      type: String,
      required: false,
      default: "",
    },
    linkRouteName: {
      type: String,
      required: false,
      default: "",
    },
    linkInactiveCondition: {
      type: Object,
      required: false,
      default: () => {},
    },
    queryName: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["initModel", "clickAction", "justifyAbsence", "downloadJustificativeFile"],
  data() {
    return {
      settingsTooltipTitle: "",
      listCheck: [],
      url: this.row[this.row.length - 1] ? fileManager.getDownloadSrc(this.row[this.row.length - 1]) : "",
      columnsItem: [],
      actionsItem: [],
    };
  },
  computed: {
    ...mapState(useUserStore, {
      permissions: (store) => store.permissions,
    }),
    ...mapState(usePlatformStore, {
      design: (store) => store.design,
    }),
  },
  mounted() {
    this.getColumnsItem();
    this.setActionsItem();
  },
  watch: {
    columns() {
      this.getColumnsItem();
    },
    row() {
      this.setActionsItem();
    },
  },
  methods: {
    initSettingsTooltip() {
      if (this.design && this.design.label) {
        return (this.settingsTooltipTitle =
          this.$tc("studea_manager.home.title", this.design.label === "Groupe" ? 2 : 1) +
          this.$t(this.design.label).toLowerCase());
      }
    },

    accessManager() {
      return accessManager;
    },

    changeListCheck() {
      this.$emit("changeListCheck", { listCheck: this.listCheck, id: this.row[this.idKey] });
    },

    initModel(row, columnIndex, columnName) {
      this.$emit("initModel", row, columnIndex, columnName);
    },

    duplicateTrainingCourseOnNextYear(id) {
      this.$emit("clickAction", {
        action: { action: "duplicateTrainingCourseOnNextYear" },
        id: id,
      });
    },

    duplicateTrainingCourse(id) {
      this.$emit("clickAction", {
        action: { action: "duplicateTrainingCourse" },
        id: id,
      });
    },

    removeTrainingCourse(id) {
      this.$emit("clickAction", {
        action: { action: "removeTrainingCourse" },
        id: id,
      });
    },

    showTriadList(id) {
      this.$emit("clickAction", {
        action: { action: "showTriadList" },
        id: id,
      });
    },

    clickAction(action) {
      this.$emit("clickAction", action);
    },

    sortPromotionByStartDate(column) {
      return sortManager.sort(column, "startYear", "DESC");
    },

    getColumnsItem() {
      if (this.type === "driver_licence") {
        this.columnsItem = this.columns.filter((item) => item.name !== "Statut");
      } else {
        this.columnsItem = this.columns;
      }
    },

    setActionsItem() {
      if (this.type === "driver_licence" && typeof this.row[7] === "string") {
        this.actionsItem = [
          {
            translation: "overview",
            icon: "eye",
            type: "success",
            action: "overviewDriverLicenceRequest",
            cfaStyle: false,
            access: accessManager.EDIT,
          },
          {
            translation: "download",
            icon: "download",
            type: "success",
            action: "downloadDriverLicenceFile",
            cfaStyle: false,
            access: accessManager.EDIT,
          },
        ];
      } else {
        this.actionsItem = this.actions;
      }
    },

    justifyAbsence(payload) {
      this.$emit("justifyAbsence", payload);
    },

    verifyAbsence(payload) {
      this.$emit("verifyAbsence", payload);
    },

    downloadJustificativeFile(payload) {
      this.$emit("downloadJustificativeFile", payload);
    },

    shouldReduceWidth(index) {
      return sortableTableManager.shouldReduceColumn(this.type, index);
    },

    shouldExpandWidth(index) {
      return sortableTableManager.shouldExpandColumn(this.type, index);
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  &__link {
    font-weight: 700;

    &.-red {
      color: $red;
    }

    &.inactive {
      &:hover {
        text-decoration: none;
      }
    }

    &:hover {
      text-decoration: underline;
    }
  }

  &__column {
    padding-right: 15px;
    padding-top: 8px;
    white-space: break-spaces;
    min-width: 100px;
    @include mobile {
      overflow: hidden;
      -ms-text-overflow: ellipsis;
      text-overflow: ellipsis;
    }

    @include up-to-lg {
      padding: 5px;
    }

    &:nth-child(2n + 1) {
      @include up-to-lg {
        background-color: $lighter-grey;
        @include dark-theme {
          background-color: $darker-grey;
        }
      }
    }

    &.list__checkable {
      @include up-to-lg {
        background-color: transparent;
      }
    }

    &.-heading {
      text-transform: capitalize;
    }

    &.text-overflow-hidden {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    @include up-to-lg {
      &:nth-child(1) {
        font-weight: 700;
        font-size: 16px;
      }
    }

    .nbTriad {
      color: dimgray;
      font-size: 10px;
    }

    .btn-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      font-size: 14px;

      &:hover,
      &:focus {
        border: 1px solid $blue;
      }
    }

    .btn-group {
      font-size: 11px;
    }

    .settings {
      width: 35px;
      height: 30px;
      position: relative;

      &:hover {
        font-size: 20px;
        color: $green;
        border: none;
      }

      &:before {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        height: 12px;
        width: 1px;
        background: var(--primary-color);

        @include up-to-md {
          content: initial;
        }
        @include mobile {
          content: "";
        }
      }
    }

    .icon-link {
      cursor: pointer;
      margin-left: 10px;
      font-size: 16px;
      width: 22px;
      height: 22px;
      padding: 0;
      color: $primary;
    }
  }

  &__checkable {
    width: 30px;
    flex: initial;
    padding: 0;
    position: relative;
    top: 5px;

    .custom-control-label {
      position: initial;

      &:before,
      &:after {
        left: 0;
      }
    }

    @include up-to-lg {
      position: absolute;
      right: unset;
      left: 5px;
      top: 3px;
    }
  }

  &__dot {
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
  }

  &__action {
    width: 15%;

    &.-row {
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
    }

    &.small {
      width: 7%;
      @include up-to-lg {
        width: 100%;
      }
    }

    @include up-to-lg {
      width: 100%;
      margin: 8px 0;
    }
  }
}

.-institution:not(:last-child) {
  @include mobile {
    margin-bottom: 10px;
  }
}

.font-size {
  @include up-to-lg {
    font-size: 12px;
  }
}

.width {
  @include up-to-lg {
    width: 100% !important;
  }
}

.institution__actions {
  &:not(:first-child) {
    margin-top: 5px;
  }
}

.training-col {
  width: 22% !important;

  @include up-to-lg {
    width: 100% !important;
  }
}

.template-col {
  width: 1% !important;

  @include up-to-lg {
    width: 100% !important;
  }
}

.template-col-1 {
  width: 25% !important;

  @include up-to-lg {
    width: 100% !important;
  }
}

.ypareo-col {
  width: 15% !important;

  @include up-to-lg {
    width: 100% !important;
  }
}

.ypareo-view-col {
  width: 50% !important;
  @include up-to-lg {
    width: 100% !important;
  }
}

.driver_licence_list {
  display: flex;
  margin-bottom: 0;
  list-style: none;
  gap: 5px;
  flex-wrap: wrap;
  padding-left: 0;
}

.driver_licence_item {
  padding: 0 5px;
  border-radius: 10px;
  border: 1px solid $black;

  &.active {
    background-color: $green;
    border-color: $green;
    color: $white;
  }
}

.pellet {
  margin-left: 10px;
  width: 15px;
  height: 15px;
  display: block;
  border-radius: 50%;
  background-color: $success;
}

.sortable__cell__text {
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
  text-wrap: nowrap;
}
</style>
